export default "__VITE_ASSET__e2bd4ff2__"